import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterDisponibilidadCpt'
})
export class FilterDisponibilidadCptPipe implements PipeTransform {

  transform<T extends { date?: string | Date }>(pa_services: T[], startDate: Date, endDate: Date): T[] {
    if (!pa_services || !Array.isArray(pa_services) || !startDate || !endDate) {
      return []; // Return an empty array if inputs are invalid
    }
    
    return pa_services.filter(service => {
      // Assuming each service has a date property to compare
      if (!service.date) return false;
      const serviceDate = new Date(service.date); // Replace 'date' with the actual date property of the service
      return !isNaN(serviceDate.getTime()) && // Ensure the date is valid
             serviceDate >= startDate && 
             serviceDate <= endDate;
    });
  }

}
